import { HttpClient } from '@angular/common/http';
import { AfterContentInit, Component } from '@angular/core';
import { Config } from '../Config';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-summary-report',
  templateUrl: './summary-report.component.html',
  styleUrls: ['./summary-report.component.css']
})
export class SummaryReportComponent implements AfterContentInit {

  public config = (window as any).config as Config;

  banner = '';
  reportType: 'construction' | 'tipvis' | 'progress';
  aoiType: 'state' | 'district' | 'county' | 'houseDistrict' | 'congressionalDistrict' | 'senateDistrict' | 'planningPartner' | 'municipality';
  aoiDisplayName: string;
  aoiValue: { value: string, display: string } = { value: '', display: '' };
  categories: { categoryName: string, count: number, cost: number, costStr?: string, isOpen: boolean }[] = [];
  reportData: IReportData[] = [];
  rawReportData: IReportData[] = [];
  totalProjects: number;
  totalCost = 0;
  totalCostStr = '';
  legislatorData: ILegislatorData;
  sort = 'projectId';
  sortReverse = true;
  categoriesWithOneMapLinks = ['Anticipated', 'Under Construction', 'TYP', 'TIP', 'Completed', 'Underway', 'Four Year', 'Twelve Year', 'Rapid Bridge Replacement'];
  isLoading = false;

  constructor(private http: HttpClient) {
  }

  ngAfterContentInit() {
    this.parseURL();
    this.setNavBarImage();
    this.getReportData();
  }

  setNavBarImage() {
    if (this.reportType === 'construction') {
      this.banner = 'constructionAppLogo';
    } else if (this.reportType === 'tipvis') {
      this.banner = 'TIPAppLogo';
    } else if (this.reportType === 'progress') {
      this.banner = 'progressAppLogo';
    }
  }

  async parseURL() {
    const url = window.location.href;
    if (url.includes('reportType=construction')) {
      this.reportType = 'construction';
    } else if (url.includes('reportType=tipvis')) {
      this.reportType = 'tipvis';
    } else if (url.includes('reportType=progress')) {
      this.reportType = 'progress';
    }

    if (url.includes('aoiType=state')) {
      this.aoiType = 'state';
      this.aoiDisplayName = 'Statewide';
      this.aoiValue.value = 'state';

    } else if (url.includes('dist=')) {
      this.aoiType = 'district';
      this.aoiDisplayName = 'District';
      const index = url.indexOf('dist=') + 'dist='.length;
      this.aoiValue.value = url.substring(index, index + 2);
      this.aoiValue.display = url.substring(index, index + 2);
    } else if (url.includes('cn=')) {
      if (url.includes('muni=')) {
        this.aoiType = 'municipality';
        this.aoiDisplayName = 'Municipality';
        let index = url.indexOf('cn=') + 'cn='.length;
        const countyValue = url.substring(index, index + 2);
        index = url.indexOf('muni=') + 'muni='.length;
        const muniValue = url.substring(index, url.length);
        this.aoiValue.display = countyValue + ' | ' + muniValue;
        this.aoiValue.value = countyValue + muniValue;
      } else {
        this.aoiType = 'county';
        this.aoiDisplayName = 'County';
        const index = url.indexOf('cn=') + 'cn='.length;
        this.aoiValue.value = url.substring(index, index + 2);
        // county aoiValue.display populated after report request returns
      }
    } else if (url.includes('houseDistrictNumber=')) {
      this.aoiType = 'houseDistrict';
      this.aoiDisplayName = 'Legislative House';
      const index = url.indexOf('houseDistrictNumber=') + 'houseDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName
                              + ' (' + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('congressDistrictNumber=')) {
      this.aoiType = 'congressionalDistrict';
      this.aoiDisplayName = 'Legislative Congress';
      const index = url.indexOf('congressDistrictNumber=') + 'congressDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName + ' ('
                              + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('senateDistrictNumber=')) {
      this.aoiType = 'senateDistrict';
      this.aoiDisplayName = 'Legislative Senate';
      const index = url.indexOf('senateDistrictNumber=') + 'senateDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName + ' ('
                              + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('mporpo=')) {
      this.aoiType = 'planningPartner';
      this.aoiDisplayName = 'Planning Partner';
      const index = url.indexOf('mporpo=') + 'mporpo='.length;
      this.aoiValue.display = url.substring(index, url.length);
      this.aoiValue.value = url.substring(index, url.length);
    }
  }

  async getReportData() {
    this.isLoading = true;
    let requestURL = 'api/reports/';
    let type: string = this.aoiType;
    if (this.aoiType === 'state') {
      type = 'statewide';
    } else if (this.aoiType === 'houseDistrict') {
      type = 'legislativehouse';
    } else if (this.aoiType === 'senateDistrict') {
      type = 'legislativesenate';
    } else if (this.aoiType === 'congressionalDistrict') {
      type = 'legislativecongress';
    }

    if (this.reportType === 'construction') {
      requestURL += 'GetConstructionReportData?aoiType=' + type + '&aoiValue=' + this.aoiValue.value;
    } else if (this.reportType === 'tipvis') {
      requestURL += 'GetTIPVisReportData?aoiType=' + type + '&aoiValue=' + this.aoiValue.value;
    } else if (this.reportType === 'progress') {
      // Progress report is state only. No params needed.
      requestURL += 'GetProgressReportData';
    }

    try {
      this.rawReportData = await this.http.get<IReportData[]>(requestURL).toPromise();
    } catch (error) {
      console.error('Error', error);
    } finally {
      if (this.aoiType === 'county') {
        let index = 0;
        while (true) {
          if (this.rawReportData[index].county !== '') {
            break;
          }
          index++;
        }
        this.aoiValue.display = this.rawReportData[index].county.trim().toUpperCase() + ' (' + this.aoiValue.value + ')';
      }
      this.totalProjects = this.rawReportData.length;

      for (const proj of this.rawReportData) {
        if (!(this.categories.findIndex(c => c.categoryName === proj.status) >= 0)) {
          this.categories.push({ categoryName: proj.status, count: 1, cost: proj.total, isOpen: false });
        } else {
          const index = this.categories.findIndex(c => c.categoryName === proj.status);
          this.categories[index].count++;
          this.categories[index].cost += proj.total;
        }

        this.totalCost += proj.total;
        proj.totalStr = this.formatCurrency(proj.total);
        proj.totalStr = proj.total === 0 ? '*' + proj.totalStr : proj.totalStr;
      }
      // Add Aviation or Transit categories if they dont exist
      if (this.reportType === 'tipvis') {
        if (this.categories.findIndex(c => c.categoryName === 'Aviation') < 0) {
          this.categories.push({ categoryName: 'Aviation', count: 0, cost: 0, isOpen: false });
        }
        if (this.categories.findIndex(c => c.categoryName === 'Transit') < 0) {
          this.categories.push({ categoryName: 'Transit', count: 0, cost: 0, isOpen: false });
        }
      }
      for (const category of this.categories) {
        category.costStr = this.formatCurrency(category.cost);
      }
      this.totalCostStr = this.formatCurrency(this.totalCost);

      /* sort categories */
      if (this.reportType === 'construction') {
        this.categories = this.categories.sort((c1, c2) => {
          if (c1.categoryName.includes('Under Construction')) {
            return -1;
          } else {
            return 1;
          }
        });
      } else if (this.reportType === 'tipvis') {
        this.categories = this.categories.sort((c1, c2) => {
          if (c1.categoryName === 'TIP') {
            return -1;
          }
          if (c2.categoryName === 'TIP') {
            return 1;
          }
          if (c1.categoryName === 'TYP') {
            return -1;
          }
          if (c2.categoryName === 'TYP') {
            return 1;
          }
          if (c1.categoryName === 'Aviation') {
            return -1;
          }
          if (c2.categoryName === 'Aviation') {
            return 1;
          }
          if (c1.categoryName === 'Transit') {
            return -1;
          }
          if (c2.categoryName === 'Transit') {
            return 1;
          }
        });
      } else if (this.reportType === 'progress') {
        this.categories = this.categories.sort((c1, c2) => {
          if (c1.categoryName === 'Completed') {
            return -1;
          }
          if (c2.categoryName === 'Completed') {
            return 1;
          }
          if (c1.categoryName === 'Underway') {
            return -1;
          }
          if (c2.categoryName === 'Underway') {
            return 1;
          }
          if (c1.categoryName === 'Four Year') {
            return -1;
          }
          if (c2.categoryName === 'Four Year') {
            return 1;
          }
          if (c1.categoryName === 'Twelve Year') {
            return -1;
          }
          if (c2.categoryName === 'Twelve Year') {
            return 1;
          }
          if (c1.categoryName === 'Rapid Bridge Replacement') {
            return -1;
          }
          if (c2.categoryName === 'Rapid Bridge Replacement') {
            return 1;
          }
        });
      }
    }
    this.reportData = this.rawReportData;
    this.isLoading = false;
  }

  async getLegislatorData() {
    const requestURL = 'api/reports/GetDistrictLegislator?districtType=' + this.aoiType + '&districtValue=' + this.aoiValue.value;

    try {
      this.legislatorData = await this.http.get<ILegislatorData>(requestURL).toPromise();
    } catch (error) {
      console.error('Error', error);
    }
  }

  formatCurrency(amount: number): string {
    // Convert number to string and add commas for thousands separator
    const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Add currency symbol and return
    return '$' + formattedAmount;
  }

  toggleCategory(index: number) {
    this.categories[index].isOpen = !this.categories[index].isOpen;
  }

  exportToCSV() {
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    let worksheet: XLSX.WorkSheet;
    let name = '';

    if (this.reportType === 'construction') {
      name = 'SummaryReport_Construction_';
    } else if (this.reportType === 'tipvis') {
      name = 'SummaryReport_TIPVis_';
    } else if (this.reportType === 'progress') {
      name = 'SummaryReport_Progress_';
    }

    worksheet = XLSX.utils.json_to_sheet(this.reportData);
    const wbName = (name + this.aoiDisplayName).substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, wbName);

    const currentDate: Date = new Date();
    const formattedDate: string = currentDate.toISOString().slice(0, 10).replace(/-/g, '_');
    XLSX.writeFile(workbook, name + this.aoiDisplayName + this.aoiValue.value + '_' + formattedDate + '.xlsx');
  }

  sortBy(sortType: string) {
    if (sortType === this.sort) {
      this.sortReverse = !this.sortReverse;
    }
    this.sort = sortType;

    this.reportData = this.reportData.sort((a, b) => {
      if (this.sort === 'projectId') {
        if (this.sortReverse) {
          return a.projectID.trim() <= b.projectID.trim() ? -1 : 1;
        } else {
          return b.projectID.trim() < a.projectID.trim() ? -1 : 1;
        }
      } else if (this.sort === 'title') {
        if (this.sortReverse) {
          return a.title.trim() <= b.title.trim() ? -1 : 1;
        } else {
          return b.title.trim() < a.title.trim() ? -1 : 1;
        }
      } else if (this.sort === 'county') {
        if (this.sortReverse) {
          return a.county.trim() <= b.county.trim() ? -1 : 1;
        } else {
          return b.county.trim() < a.county.trim() ? -1 : 1;
        }
      } else if (this.sort === 'improvementType') {
        if (this.sortReverse) {
          return a.improvementType.trim() <= b.improvementType.trim() ? -1 : 1;
        } else {
          return b.improvementType.trim() < a.improvementType.trim() ? -1 : 1;
        }
      } else if (this.sort === 'totalStr') {
        if (this.sortReverse) {
          return a.total - b.total;
        } else {
          return b.total - a.total;
        }
      } else if (this.sort === 'parentProjectId') {
        if (this.sortReverse) {
          return a.parentProjectId - b.parentProjectId;
        } else {
          return b.parentProjectId - a.parentProjectId;
        }
      }
    });
  }
}

interface IReportData {
  county: string;
  description: string;
  improvementType: string;
  parentProjectId: number;
  projectID: string;
  status: string;
  title: string;
  total: number;
  totalStr: string;
}
interface ILegislatorData {
  firstName: string;
  lastName: string;
  party: string;
  homeCounty: string;
}
